module.exports = __webpack_public_path__ + "img/未支付报名费.6b70d83a.png";